import React from 'react';
import Subscription from '../../types/Subscription';

export const SubscriptionContext = React.createContext<
    Subscription | undefined
>(undefined);
